/**
 * Cleo ERP SaaS — Layout pages publiques
 * Fond gradient Clouder, panneau central blanc.
 */
import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { Typography } from 'antd';

function PublicLayout() {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0F172A, #064E3B, #10B981)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
    }}>
      {/* Logo / Titre */}
      <Link to="/" style={{ marginBottom: 32, textAlign: 'center' }}>
        <Typography.Title level={2} style={{
          color: '#FFFFFF',
          margin: 0,
          fontWeight: 700,
        }}>
          Cleo ERP
        </Typography.Title>
        <Typography.Text style={{ color: 'rgba(255,255,255,0.65)', fontSize: 13 }}>
          La gestion d'entreprise, simplement.
        </Typography.Text>
      </Link>

      {/* Panneau contenu */}
      <div style={{
        background: '#FFFFFF',
        borderRadius: 12,
        padding: '40px 32px',
        width: '100%',
        maxWidth: 480,
        boxShadow: '0 25px 50px rgba(0,0,0,0.25)',
      }}>
        <Outlet />
      </div>

      {/* Footer */}
      <div style={{ marginTop: 24, textAlign: 'center' }}>
        <Typography.Text style={{ color: 'rgba(255,255,255,0.5)', fontSize: 12 }}>
          © 2026 EC Intelligence — Cleo ERP SaaS
        </Typography.Text>
      </div>
    </div>
  );
}

export default PublicLayout;
